// @flow
import React, { type Node as React$Node, type ComponentType } from 'react';
import PropTypes from 'prop-types';
import { RendererProvider } from 'react-fela';

type Props = {|
  Button: ComponentType<*>,
  Image: ComponentType<*>,
  Text: ComponentType<*>,
  TextInput: ComponentType<*>,
  View: ComponentType<*>,
  mountNode?: ?HTMLStyleElement | '',
  renderer: (props: ComponentType<*>) => React$Node,
  children: React$Node,
|};

// Enhance Fela provider for universal base components.
export default class FelaProvider extends React.Component<Props> {
  static childContextTypes = {
    Button: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    Image: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    Text: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    TextInput: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    View: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  };

  getChildContext() {
    const { Button, Image, Text, TextInput, View } = this.props;
    return { Button, Image, Text, TextInput, View };
  }

  render() {
    const { children, renderer } = this.props;

    return <RendererProvider renderer={renderer}>{children}</RendererProvider>;
  }
}
